export const dispatchNativeEvent = (
  elm: HTMLElement | null | undefined,
  events: string[],
  { ...valueObj } = {}
) => {
  if (elm) {
    const [prop, value] = Object.entries(valueObj)[0] ?? [];

    const desc = Object.getOwnPropertyDescriptor(
      Object.getPrototypeOf(elm),
      prop
    );

    desc?.set?.call(elm, value);

    events.forEach(event => {
      if (event === 'focus') {
        elm.dispatchEvent(new Event('focusin', { bubbles: true }));
      } else if (event === 'blur') {
        elm.dispatchEvent(new Event('focusout', { bubbles: true }));
      } else {
        elm.dispatchEvent(new Event(event, { bubbles: true }));
      }
    });
  }
};
